import { getJourneyObjectTypeId } from 'reporting-enablement/components/reportEditors/common/journeyHelpers';
import { EXPLICIT_DATA_TYPE_TO_FAMILY } from '../../../constants/recommendations/DataTypeFamilies';
import { getDataTypeFamiliesByKeyword, getDataTypeFamiliesForDataSource } from '../categorizationUtils/dataTypeFamilyUtils';
const getJourneyEventTables = report => report.journeyQuery.stages.map(stage => stage.steps.map(step => step.query.table)).flat();
export const getDataTypeFamiliesFromJourneyReport = report => {
  const objectId = getJourneyObjectTypeId(report);
  const objectFamilies = getDataTypeFamiliesForDataSource(objectId);
  const eventTables = getJourneyEventTables(report);
  const dataTypeFamilies = eventTables.flatMap(table => {
    var _table$join;
    const joinedObject = (_table$join = table.join) === null || _table$join === void 0 || (_table$join = _table$join[0]) === null || _table$join === void 0 || (_table$join = _table$join.target) === null || _table$join === void 0 ? void 0 : _table$join.objectTypeId;
    const joinedObjFamilies = joinedObject ? getDataTypeFamiliesForDataSource(joinedObject) : [];
    if (joinedObjFamilies.length) {
      return joinedObjFamilies;
    }
    const eventName = table.name;
    const eventFamilies = EXPLICIT_DATA_TYPE_TO_FAMILY[eventName] || getDataTypeFamiliesByKeyword(eventName) || [];
    if (eventFamilies.length) {
      return eventFamilies;
    }
    return objectFamilies;
  });

  // Not ordering by frequency because I want to favor the earlier events over the later ones
  return [...new Set(dataTypeFamilies)];
};